"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WALLET_AMOUNT_MESSAGE_BANNER_LOCAL_STORAGE_KEY = exports.WALLET_AMOUNT_MESSAGE_BANNER_CLOSE_ICON = exports.WALLET_AMOUNT_MESSAGE_BANNER_AMOUNT = exports.WALLET_AMOUNT_MESSAGE_BANNER = void 0;
const WALLET_AMOUNT_MESSAGE_BANNER_LOCAL_STORAGE_KEY = exports.WALLET_AMOUNT_MESSAGE_BANNER_LOCAL_STORAGE_KEY = 'walletAmountMessageBannerClosed';
const WALLET_AMOUNT_MESSAGE_BANNER = exports.WALLET_AMOUNT_MESSAGE_BANNER = 'wallet-amount-message-banner';
const WALLET_AMOUNT_MESSAGE_BANNER_CLOSE_ICON = exports.WALLET_AMOUNT_MESSAGE_BANNER_CLOSE_ICON = 'wallet-amount-message-banner-close-icon';
const WALLET_AMOUNT_MESSAGE_BANNER_AMOUNT = exports.WALLET_AMOUNT_MESSAGE_BANNER_AMOUNT = 'wallet-amount-message-banner-amount';